import Vue from 'vue';
import notify from 'vue2-notify';

// Default notifications configuration: vue2-notify
Vue.use(notify, {
    itemClass: '',
    permanent: false,
    duration: 300,
    visibility: 5000,
    // closeButtonClass: 'close',
    position: 'bottom-right'
});

Vue.$notify.setTypes({
    info: {itemClass: 'toaster', iconClass: 'toaster__icon mdi mdi-information'},
    error: {itemClass: 'toaster--error', iconClass: 'toaster__icon mdi mdi-alert-circle'},
    warning: {itemClass: 'toaster--warning', iconClass: 'toaster__icon mdi mdi-alert'},
    success: {itemClass: 'toaster--success', iconClass: 'toaster__icon mdi mdi-checkbox-marked-circle'}
});



// WEBPACK FOOTER //
// ./src/notifications.js